import { useGlobal } from '@/utils/useGlobal';
import { useEffect } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

export default function J() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.J');

    useEffect(() => {
        const AniContainer = window?.AniContainer;
        AniContainer.create({
            syncFromTo: [
                ['.power-ocean-home-I .black-bg', { opacity: 0 }, { opacity: 1 }],
                ['.power-ocean-home-J .black-bg', { opacity: 0 }, { opacity: 1 }],
            ],
            triggerElement: '.power-ocean-home-J',
            triggerHook: 1,
            offset: '25%',
            duration: '50%',
            scrollUpdatePos: true,
        });

        AniContainer.create({
            syncFromTo: [
                ['.power-ocean-home-J .title', { opacity: 0 }, { opacity: 1 }],
                ['.power-ocean-home-J .img-box', { opacity: 0.5 }, { opacity: 1 }],
            ],
            triggerElement: '.power-ocean-home-J .title',
            triggerHook: 1,
            duration: 300,
            offset: 0,
            scrollUpdatePos: true,
        });
    }, []);

    return (
        <div className={`power-ocean-home-J ${styles['power-ocean-home-J']}`}>
            <div className="sec10">
                <div className="text-box">
                    <p className="subtitle">{t('label')}</p>
                    <h2 className="title">{t('title')}</h2>
                    <p className="desc">{t('desc')}</p>
                </div>
                <div className="img-box">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1762829783943/ocean_J_1_eu.png"
                        pad="https://websiteoss.ecoflow.com/upload/image/1762829791431/ocean_J_1_h5_eu.png"
                        alt={t`Smart monitoring and control with ease`}
                    />
                </div>
            </div>
            <div className="black-bg"></div>
        </div>
    );
}
